import { useState } from "react";
import { DateInputWithLabel } from "./DateInputWithLabel"
import { TimePickerWithLabel } from "./TimePickerWithLabel"
import dayjs from "newui/utils/dayjs";

interface DateTimePickerWithLabelProps {
	dateFieldName: string;
	defaultDate?: Date,
	defaultDaysFromToday?: number;
	defaultTime?: string;
	label: string;
	required?: boolean;
	timeFieldName: string;
	timeZoneFieldName: string;
	onValueChanged?: (date: Date, time: string, timezone: string) => void;
}

export const DateTimePickerWithLabel = (
	{ dateFieldName,
		defaultDate,
		defaultDaysFromToday,
		defaultTime = "05:00 PM",
		label,
		required = false,
		timeFieldName,
		timeZoneFieldName,
		onValueChanged
	}: DateTimePickerWithLabelProps) => {

	const defaultDays = defaultDaysFromToday ?? 7;
	const [dateDue, setDateDue] = useState(dayjs(defaultDate ?? Date.now()).add(defaultDays, "days").toDate());
	const [timeDue, setTimeDue] = useState(defaultTime);
	const [timezone, setTimezone] = useState(dayjs.tz.guess());
	const [error, setError] = useState("");

	const handleDateChange = (value: Date) => {
		setDateDue(value);
		if (error) {
			setError("");
		}

		onValueChanged(value, timeDue, timezone);
	};

	const handleTimeChange = (value: string) => {
		setTimeDue(value);
		if (error) {
			setError("");
		}

		onValueChanged(dateDue, value, timezone);
	};

	const handleTimezoneChange = (value: string) => {
		setTimezone(value);
		if (error) {
			setError("");
		}

		onValueChanged(dateDue, timeDue, value);
	};

	return <>
		<div>
			<DateInputWithLabel
				hasError={!!error}
				label={label}
				name={dateFieldName}
				required={required}
				value={dateDue}
				onChange={handleDateChange}
				minDate={dayjs().add(24, "hours").toDate()}
			/>
		</div>

		<div>
			<TimePickerWithLabel
				name={timeFieldName}
				nameTimezone={timeZoneFieldName}
				value={timeDue}
				timezone={timezone}
				onTimeChange={handleTimeChange}
				onTimeZoneChange={handleTimezoneChange}
				required={required}
				restrictTimezones="Australia"
			/>
		</div>
	</>
}